



































































import { ref, computed, defineComponent, watch, PropType } from '@vue/composition-api';
import { changeFilterFormDate, pickerOptions } from '../filter'
import { buttonList, FilterFormItemType, ConditionsType } from '../types';
import { addDays, differenceInDays } from 'date-fns';
import { handleWarningMessageToast } from '@/common/util';
import QaTips from './qa-tips.vue';

export default defineComponent({
    name: "select-nav", // ICP备案主页面
    components: {
        QaTips
    },
    props: {
        selectList: {
            type: Array,
            required: true,
        },
        appId: {
            type: String,
            required: true,
        },
        allLoading: {
            type: Boolean,
            required: true,
        },
        value: {
            type: Array as PropType<FilterFormItemType[]>,
            default: ()=> []
        },
        showFastTime: {
            type: Boolean,
            default: true
        }
    },
    model: {
        prop: 'value',
        event: 'update',
    },
    setup(props, context) {
        // const pickerOptions = {
        //     disabledDate(time: Date) {
        //         // 只能查询2024.4.1 至 昨天 之间的数据
        //         const yesterday = addDays(new Date(), -1).getTime();
        //         const startDate = new Date('2024/4/1').getTime();
        //         return time.getTime() > yesterday || time.getTime() < startDate;
        //     }
        // }
        const buttonAcitve = ref(buttonList[1].value); // 选择按钮, 默认选中近7天
        const timeRange = ref<number[]>(buttonList[1].value); // 选择时间
        const fillterForm = computed({
            get: () => {
                return props.value;
            },
            set: (val) => {
                return context.emit('update', val);
            },
        });

        const defaultRange = computed(() => {
            const end = new Date();
            const start = new Date();
            // 设置为上个月的今天
            start.setMonth(start.getMonth() - 1);
            end.setMonth(end.getMonth() + 1);
            return [start, end]
        })

        function getIndex (item: ConditionsType){
            const form = fillterForm.value as FilterFormItemType[];
            return form.findIndex((val: FilterFormItemType) => val.fieldName === item.fieldName)
        }

        // 游戏发生改变后，筛选条件需要重置
        // 但是因为timeRange、buttonAcitve 与fillterForm的匹配关系太复杂，所以这里简单写，直接置为初始值
        watch(
            () => props.appId,
            async (val) => {
                // console.log('nav导航区域appId发生了改变',props.appId)
                timeRange.value = buttonAcitve.value;
                buttonAcitve.value = buttonList[1].value
            }
        );

        // 时间选择发生变化
        function pickTimeChange(val: number[]) {
            if(val.length === 0) return;
            const differDay = differenceInDays(
                new Date(val[1]),
                new Date(val[0])
            )
            if(differDay > 31) {
                handleWarningMessageToast("一次最多可查询31天");
                return;
            }
            // 清空按钮选择器
            buttonAcitve.value = [];
            // 更新父组件fillterForm
            context.emit('update', changeFilterFormDate(fillterForm.value as FilterFormItemType[], val));
        }

        // 选择按钮时间
        function clickButton(item: {text: string; value: number[]}) {
            if(buttonAcitve.value === item.value) return;
            buttonAcitve.value = item.value;
            // 日期选择器展示按钮选择时间
            timeRange.value =  buttonAcitve.value;
            // console.log('计算后的值', changeFilterFormDate(fillterForm.value as FilterFormItemType[] , buttonAcitve.value))
            // 更新父组件fillterForm
            context.emit('update', changeFilterFormDate(fillterForm.value as FilterFormItemType[], buttonAcitve.value));
        }

        function clickRest() {
            buttonAcitve.value = buttonList[1].value;
            timeRange.value = buttonAcitve.value
            context.emit('rest')
        }
        return {
            defaultRange,
            clickRest,
            pickTimeChange,
            timeRange,
            fillterForm,
            getIndex,
            buttonList,
            clickButton,
            buttonAcitve,
            pickerOptions
        }
    },
})
